import React from 'react';
import PropTypes from '../../types';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Form } from 'react-final-form';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import ShareHolder from './shareHolders';
import OfficerComponent from './officerComponent';
import { getControlBusinessValues } from '../../infrastructure/officer/payloadUtils/mapOfiicerDetails';

const SignificantPeoplePage = ({
  brandId,
  bankId,
  saveSignificantPeopleForm,
  officersDetails,
  addressHistory,
  isSoleTrader,
  redirectToAddShareholderPage,
  saveOfficerDetails,
  removeOfficerDetails,
  userName,
  signatoriesAndShareholder,
  saveSignatoriesAndShareholdersForm,
  primaryApplicant,
  linkCode
}) => {
  return (
    <Form
      onSubmit={saveSignificantPeopleForm}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({
              significantPeopleLimitedCompanyPageTitle = '',
              significantPeopleLimitedCompanyContentA,
              significantPeopleLimitedCompanyContentB,
              significantPeopleLimitedCompanyContentC,
              significantPeopleLimitedCompanyContentD,
              significantPeopleSoleTraderPageTitle = '',
              significantPeopleSoleTraderContentA,
              significantPeopleSoleTraderContentB
            }) => (
              <div>
                {!isSoleTrader ? (
                  <div>
                    <PageHeading>{significantPeopleLimitedCompanyPageTitle}</PageHeading>
                    <StandardBody>
                      <p>{significantPeopleLimitedCompanyContentA}</p>

                      <BulletList
                        items={[
                          significantPeopleLimitedCompanyContentB,
                          significantPeopleLimitedCompanyContentC
                        ]}
                      />

                      <p>{significantPeopleLimitedCompanyContentD}</p>
                    </StandardBody>
                  </div>
                ) : (
                  <div>
                    <PageHeading>{significantPeopleSoleTraderPageTitle}</PageHeading>
                    <StandardBody>
                      <p>{significantPeopleSoleTraderContentA}</p>

                      <p>{significantPeopleSoleTraderContentB}</p>
                    </StandardBody>
                  </div>
                )}
                {!linkCode && (
                  <ShareHolder
                    brandId={brandId}
                    bankId={bankId}
                    isSoleTrader={isSoleTrader}
                    saveSignatoriesAndShareholdersForm={saveSignatoriesAndShareholdersForm}
                    signatoriesAndShareholder={signatoriesAndShareholder}
                    primaryApplicant={primaryApplicant}
                    shareHolderInfo={getPrimaryApplicant(
                      userName,
                      getControlBusinessValues(signatoriesAndShareholder, primaryApplicant)
                    )}
                  />
                )}
                {officersDetails ? (
                  officersDetails.map((officer, index) => (
                    <OfficerComponent
                      key={`officer${index}`}
                      officerInfo={officer}
                      randId={brandId}
                      bankId={bankId}
                      linkCode={linkCode}
                      index={index}
                      isSoleTrader={isSoleTrader}
                      addressHistory={addressHistory}
                      removeOfficerDetails={removeOfficerDetails}
                      saveOfficerDetails={saveOfficerDetails}
                    />
                  ))
                ) : (
                  <span />
                )}
                {!linkCode && (
                  <div className="u-margin-top-3">
                    <ActionButton.Add
                      labelText="Add someone else"
                      onClick={() => redirectToAddShareholderPage()}
                    />
                  </div>
                )}
                {linkCode && <div className="u-margin-top-3 u-margin-bottom-2" />}
                <Submit />
              </div>
            )}
          </Content>
        </form>
      )}
    />
  );
};

SignificantPeoplePage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveSignificantPeopleForm: PropTypes.func.isRequired
};

const getPrimaryApplicant = (userName, signatoriesAndShareholder) => {
  return {
    name: userName,
    authorisedSignatory: 'Yes',
    significantShareHolder: signatoriesAndShareholder ? signatoriesAndShareholder.control : '',
    percentageOfCompanyShares: signatoriesAndShareholder
      ? signatoriesAndShareholder.controlling_percentage
      : ''
  };
};

export default SignificantPeoplePage;
